import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import Less from 'less'
import App from './App.vue'
import router from './router'
import '@/assets/css/iconfont.css' //阿里图标库引入
import '@/assets/css/common.less' //公共样式引入
import '@/assets/css/index.less' //页面样式less
import '@/assets/css/font-iconfont.css'; /*引入编辑器样式*/
import api from './http/api.js'
import echarts from 'echarts'; //echarts 图表
// import vueSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import fullscreen from 'vue-fullscreen'

Vue.use(fullscreen)


//图片裁剪
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

import { getCookie , delCookie , setCookie ,statPushPost } from '@/assets/js/util';// cookie操作

Vue.prototype.$api = api;
Vue.prototype.$getCookie = getCookie;
Vue.prototype.$setCookie = setCookie;
Vue.prototype.$delCookie = delCookie;
Vue.prototype.$statPushPost = statPushPost;

Vue.config.productionTip = false
Vue.use(ElementUI);


// 根据路由设置标题
router.beforeEach((to, from, next) => {

  if(to.meta.title) {
    document.title = to.meta.title
  }

  /*路由发生改变修改页面的title */
  if(to.path != '/login' && to.path != '/register'){
    localStorage.setItem('login_backurl',to.path);
  }
	var token = getCookie('sd_token');

  if(typeof(to.meta.checkLogin) != undefined && to.meta.checkLogin){
    if(token){
      next();
    }else{
      // next({
      //   path: '/login',
      //   query:{
      //     redirect:to.fullPath
      //   }
      // });
    }
  }else{
    next();
  }

});

router.afterEach((to, from) => {
	
	//判断是否自动统计
	if(to.meta.autoStat != false || to.meta.autoStat){
		var itemCode = null;
		if(typeof(to.params.code) != undefined){
			itemCode = to.params.code;
		}
		var params = {
			  "eventAction": "view",
			  "eventCategory": "view",
			  "optLabel": "",
			  "optValue": "",	//只是存里边看一下值
			  "url": to.fullPath,
			  "Referrer": from.fullPath,
			  "pageCode": to.name,
			  "itemCode": itemCode
		};
		
		Vue.prototype.$statPushPost(params);
	}

})

new Vue({
  router,
  store,  //store:store 和router一样，将我们创建的Vuex实例挂载到这个vue实例中
  render: h => h(App)
}).$mount('#app')
